import { Tooltip } from "../../tooltip";
import { Text } from "../../text";
import { AiSummaryIcon } from "@edgetier/components";
import styles from "./ai-icon-tooltip.module.scss";
import { FunctionComponent, useMemo } from "react";
import { IProps } from "./ai-icon-tooltip.types";
import { Center } from "../../center";

/**
 * AI Icon Tooltip component
 *
 * @param {IProps} props - Component props
 * @param {string | JSX.Element} [props.label] - Tooltip label
 *
 * @returns {JSX.Element} AI Icon Tooltip
 */
const AiIconTooltip: FunctionComponent<IProps> = ({ label }) => {
    const defaultLabel = useMemo(
        () => (
            <Text size="sm">
                Built on your teams quality standards,{" "}
                <Text span variant="semibold" c="var(--mantine-color-text-link)">
                    Auto QA
                </Text>{" "}
                is used by EdgeTiers AI to review relevant interactions automatically.{" "}
            </Text>
        ),
        []
    );
    return (
        <Tooltip withArrow maw={220} multiline label={label ?? defaultLabel}>
            <Text span>
                <Center p="xs" className={styles["icon"]} bdrs="xl">
                    <AiSummaryIcon svgProps={{ width: "1.6rem", height: "1.6rem" }} />
                </Center>
            </Text>
        </Tooltip>
    );
};

export { AiIconTooltip };
